import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { HebergementBnbaccess } from './hebergement-bnbaccess.model';
import { HebergementBnbaccessPopupService } from './hebergement-bnbaccess-popup.service';
import { HebergementBnbaccessService } from './hebergement-bnbaccess.service';

@Component({
    selector: 'jhi-hebergement-bnbaccess-delete-dialog',
    templateUrl: './hebergement-bnbaccess-delete-dialog.component.html'
})
export class HebergementBnbaccessDeleteDialogComponent {

    hebergement: HebergementBnbaccess;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private hebergementService: HebergementBnbaccessService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['hebergement']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.hebergementService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'hebergementListModification',
                content: 'Deleted an hebergement'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-hebergement-bnbaccess-delete-popup',
    template: ''
})
export class HebergementBnbaccessDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private hebergementPopupService: HebergementBnbaccessPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.hebergementPopupService
                .open(HebergementBnbaccessDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess-delete-dialog.component.ts